// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Label_label__dXgQ\\+ {
  display: flex;
  justify-content: center;
  margin-top: 80px;
  width: 100%;
}
.Label_labelContainer__A60-y {
  display: flex;
  width: 100%;
  max-width: 1110px;
  flex-direction: column;
}


.Label_topText__VsZQn {
  color: white;
  font-size: var(--font-size-4xl);
  font-weight: var(--font-semibold, 600);
  line-height: 1.4;
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
  text-align: left;
}

.Label_bottomText__8n9j7 {
  color: var(--color-accent, #4CAF50);
  font-size: var(--font-size-4xl, 1.5rem);
  font-weight: var(--font-bold, 700);
  line-height: 1.4;
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.3);
  position: relative;
  text-align: left;
}

/* Смещения для нижней строки */
.Label_shift-small__ukYOk {
  margin-left: 20px;
}

.Label_shift-medium__6u3bc {
  margin-left: 100px;
}

.Label_shift-large__4Z\\+-0 {
  margin-left: 150px;
}

/* Адаптивность для мобильных устройств */
@media (max-width: 768px) {
  .Label_topText__VsZQn {
    font-size: var(--font-size-2xl);
  }
  
  .Label_bottomText__8n9j7 {
    font-size: var(--font-size-xl);
  }
  
  .Label_shift-small__ukYOk {
    margin-left: 10px;
  }
  
  .Label_shift-medium__6u3bc {
    margin-left: 20px;
  }
  
  .Label_shift-large__4Z\\+-0 {
    margin-left: 30px;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/EntToEndUI/Label/Label.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,sBAAsB;AACxB;;;AAGA;EACE,YAAY;EACZ,+BAA+B;EAC/B,sCAAsC;EACtC,gBAAgB;EAChB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,uCAAuC;EACvC,kCAAkC;EAClC,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,yCAAyC;AACzC;EACE;IACE,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".label {\n  display: flex;\n  justify-content: center;\n  margin-top: 80px;\n  width: 100%;\n}\n.labelContainer {\n  display: flex;\n  width: 100%;\n  max-width: 1110px;\n  flex-direction: column;\n}\n\n\n.topText {\n  color: white;\n  font-size: var(--font-size-4xl);\n  font-weight: var(--font-semibold, 600);\n  line-height: 1.4;\n  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);\n  text-align: left;\n}\n\n.bottomText {\n  color: var(--color-accent, #4CAF50);\n  font-size: var(--font-size-4xl, 1.5rem);\n  font-weight: var(--font-bold, 700);\n  line-height: 1.4;\n  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.3);\n  position: relative;\n  text-align: left;\n}\n\n/* Смещения для нижней строки */\n.shift-small {\n  margin-left: 20px;\n}\n\n.shift-medium {\n  margin-left: 100px;\n}\n\n.shift-large {\n  margin-left: 150px;\n}\n\n/* Адаптивность для мобильных устройств */\n@media (max-width: 768px) {\n  .topText {\n    font-size: var(--font-size-2xl);\n  }\n  \n  .bottomText {\n    font-size: var(--font-size-xl);\n  }\n  \n  .shift-small {\n    margin-left: 10px;\n  }\n  \n  .shift-medium {\n    margin-left: 20px;\n  }\n  \n  .shift-large {\n    margin-left: 30px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `Label_label__dXgQ+`,
	"labelContainer": `Label_labelContainer__A60-y`,
	"topText": `Label_topText__VsZQn`,
	"bottomText": `Label_bottomText__8n9j7`,
	"shift-small": `Label_shift-small__ukYOk`,
	"shift-medium": `Label_shift-medium__6u3bc`,
	"shift-large": `Label_shift-large__4Z+-0`
};
export default ___CSS_LOADER_EXPORT___;
